import styled from "styled-components";
import { SeparatorDefaultBox } from "./separator.default.box";

export const Separator777Box = styled(SeparatorDefaultBox)`
    width: 2px;
`;
